import React from 'react';
export function Footer() {
  return <footer className="bg-forestdeep pt-14 pb-10 relative overflow-hidden" data-id="element-87">
      <svg className="absolute right-0 bottom-0 opacity-[0.07] pointer-events-none hidden sm:block" width="300" height="200" viewBox="0 0 340 220" fill="none" stroke="#FFFFFF" strokeWidth="1.4" aria-hidden="true" data-id="element-88">
        <path d="M250 210c-30-10-46-34-46-62 0-30 22-54 50-54 26 0 46 20 46 48 0 4 0 8-1 12" data-id="element-89" />
        <ellipse cx="250" cy="150" rx="34" ry="46" transform="rotate(18 250 150)" data-id="element-90" />
        <ellipse cx="300" cy="170" rx="26" ry="36" transform="rotate(-10 300 170)" data-id="element-91" />
        <circle cx="100" cy="120" r="22" data-id="element-92" />
      </svg>

      <div className="max-w-7xl mx-auto px-5 sm:px-8 relative" data-id="element-93">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-6" data-id="element-94">
          <a href="#top" className="flex items-center" aria-label="AFEXA — Africa Commodity Exchange home" data-id="element-95">
            <img src="https://cdn.magicpatterns.com/uploads/g6ebYu1Xjz1ZLZcTiKmQS5/background-removed.png" alt="AFEXA — Africa Commodity Exchange" className="h-12 w-auto brightness-0 invert" data-id="element-96" />
          </a>

          <a href="#contact" className="btn-pill bg-gold hover:bg-goldlight text-forestdeep text-sm px-6 py-3 self-start sm:self-auto" data-id="element-97">
            Talk to AFEXA
          </a>
        </div>

        <div className="mt-10 pt-6 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-2 text-xs text-paper/40" data-id="element-98">
          <p data-id="element-99">© {new Date().getFullYear()} AFEXA — Africa Farmers Exchange.</p>
          <p data-id="element-100">Built for Kenya's agricultural economy.</p>
        </div>
      </div>
    </footer>;
}